import React from "react";
import { css } from "@emotion/react";
// import Skeleton from "@mui/material/Skeleton";
// import Stack from "@mui/material/Stack";
import { Skeleton, Stack, Box, Grid } from "@mui/material";

export function DashboardShimmer() {
  return (
    <Box className="p-4 w-full space-y-4">
      {/* Top 4 small boxes */}
      <Box className="flex flex-col md:flex-row gap-4">
        {[1, 2, 3, 4].map((_, i) => (
          <Stack
            key={i}
            spacing={1}
            className="p-4 rounded-xl shadow bg-white flex-1"
          >
            <Skeleton variant="text" width="50%" />
            <Skeleton variant="text" width="70%" height={25} />
          </Stack>
        ))}
      </Box>

      {/* Bottom 2 bigger boxes */}
      <Box className="flex flex-col md:flex-row  gap-4">
        <Stack
          spacing={2}
          className="p-4 rounded-xl shadow bg-white flex-1 h-96 flex justify-center items-center"
        >
          <Skeleton
            variant={"rectangular"}
            width={"90%"}
            height={250}
          />

        </Stack>
        <Stack
          spacing={2}
          className="p-4 rounded-xl shadow bg-white flex-1 h-96 flex justify-center items-center"
        >
          <Skeleton
            variant={"circular"}
            width={"40%"}
            height={250}
          />

        </Stack>
      </Box>
      <Box className="flex-1 gap-4">

        <Stack
          spacing={2}
          className="p-4 rounded-xl shadow bg-white flex-1 h-96 w-5/12 flex justify-center items-center"
        >
          <Skeleton
            variant={"circular"}
            width={"40%"}
            height={250}
          />

        </Stack>
      </Box>
    </Box>


  );
}

const ShimmerLoader = ({ loading }) => {
  const override = css`
    display: block;
    margin: auto;
    border-color: red; // Customize the color if needed
  `;

  return (
    <Stack spacing={1}>
      <Skeleton variant="text" sx={{ fontSize: "1rem" }} />
      <Skeleton variant="rectangular" width={485} height={30} />
      <Skeleton variant="rectangular" width={210} height={20} />
      <Skeleton variant="rounded" width={685} height={40} />
      <Skeleton variant="text" sx={{ fontSize: "1rem" }} />
      <Skeleton variant="text" sx={{ fontSize: "1rem" }} />
      {/* <Skeleton variant="rectangular" width={210} height={20} /> */}
      <Skeleton variant="text" sx={{ fontSize: "1rem" }} />
      <Skeleton variant="rectangular" width={485} height={30} />
      <Skeleton variant="text" sx={{ fontSize: "1rem" }} />
      <Skeleton variant="rectangular" width={210} height={20} />
      <Skeleton variant="rounded" width={685} height={40} />


      {/* <Skeleton variant="rectangular" width={385} height={60} /> */}
    </Stack>
  );
};

export default ShimmerLoader;
